module.exports = __webpack_public_path__ + "img/block7-card4.08b15b69.svg";